<template>
  <div>
    <v-btn icon @click.stop="showPopup()">
      <v-icon>{{icon}}</v-icon>
      <StandardBadge
      v-if="show_badge"
      :text="badge_text"
      color="white"
      content_color="black"
      />
    </v-btn>
    <transition name="card-dropdown-transition">
      <div v-if="show" class="card-dropdown">
        <div class="card-dropdown-header">
          <div @click.stop="changeTab('user')" :class="isActiveTab('user') ? 'card-dropdown-header-item card-dropdown-header-item-active' : 'card-dropdown-header-item'">
            {{$t('AppLayout.NavBar.Messages.UserNotifications')}}
          </div>
          <div @click.stop="changeTab('system-notification')" :class="isActiveTab('system-notification') ? 'card-dropdown-header-item card-dropdown-header-item-active' : 'card-dropdown-header-item'">
            {{$t('AppLayout.NavBar.Messages.SystemNotifications')}}
          </div>
          <div @click.stop="changeTab('system-warning')" :class="isActiveTab('system-warning') ? 'card-dropdown-header-item card-dropdown-header-item-active' : 'card-dropdown-header-item'">
            {{$t('AppLayout.NavBar.Messages.SystemWarnings')}}
          </div>
        </div>
        <div v-if="isActiveTab('user')" class="card-dropdown-content">
          <div v-if="user_notifications.length === 0">
            {{$t('AppLayout.NavBar.Messages.NoUserNotifications')}}
          </div>
          <div
            v-for="item in user_notifications"
            :key="item.id"
            class="card-dropdown-content-item"
            @click.stop="routeTo(item)"
          >
            <div class="card-dropdown-content-item-left">
              <!-- v-if="item.coded_wp" -->
              <WorkPackage
                v-if="item.twork_packages.length"
                :color="`${item.twork_packages[0].color} ${item.twork_packages[0].color.includes('lighten') || item.twork_packages[0].color.includes('darken')? '':'lighten-1'}`"
                :token="item.twork_packages[0].token"
                :icon="item.twork_packages[0].icon"
                :zoom="1"
                >
              </WorkPackage>
              <v-avatar v-else size="40" color="grey">
                <span class="white--text pl-1">P</span>
              </v-avatar>
            </div>
            <div class="card-dropdown-content-item-right">
              {{ item.text }}
            </div>
          </div>
        </div>
        <div v-if="isActiveTab('system-notification')" class="card-dropdown-content">
          <div class="card-dropdown-content-item">
            {{$t('AppLayout.NavBar.Messages.AutomaticNotificationsOffline')}}
          </div>
        </div>
        <div v-if="isActiveTab('system-warning')" class="card-dropdown-content">
          <div class="card-dropdown-content-item">
            {{$t('AppLayout.NavBar.Messages.AutomaticWarningsOffline')}}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
export default {
  props: ['icon', 'show_badge', 'badge_text', 'user_notifications'],
  data: () => ({
    show: false,
    tab: 'user'
  }),
  components: {
    StandardBadge, WorkPackage
  },
  computed: {

  },
  mounted(){
  },
  methods: {
    showPopup(){
      if (this.show) {
        this.onClickOutside();
      } else {
        document.body.addEventListener('click', this.onClickOutside);
        this.show = true;
      }
    },
    onClickOutside(){
      if (this.show) {
        this.show = false;
        document.body.removeEventListener('click', this.event)
      }
    },
    routeTo(item){
      if (item.twork_packages.length) {
        this.$router.push({
          name: 'TaktPlanWorkPackageMessageBoard',
          params: {
            project_id: item.twork_packages[0].project_id,
            train_id: item.twork_packages[0].train_id,
            taktarea_id: item.twork_packages[0].taktarea_id,
            twaggon_id: item.twork_packages[0].twaggon_id,
            tworkpackage_id: item.twork_packages[0].id,
          }
        });
      } else {
        this.$router.push({
          name: 'ProjectMessageBoard',
          params: {
            project_id: item.projects[0].id,
          }
        });
      }

      this.onClickOutside();

    },
    changeTab(tab){
      this.tab = tab;
    },
    isActiveTab(tab){
      return this.tab === tab;
    }
  }
}
</script>
<style scoped>
.card-dropdown {
  position: absolute;
  width: 500px;
  background-color: #292929;
  right: 150px;
  opacity: 1;
  border-radius: 4px;
}
.card-dropdown-header {
  display: flex;
  justify-content: space-around;
  background-color: #1e1e1e;
  /* height: 100%;
  width: 100%; */
  cursor: pointer;
}
.card-dropdown-header-item {
  height: 100%;
  width: 100%;
  padding: 5px;
  text-align: center;
  transition: background-color 0.2s ease-in-out;
}
.card-dropdown-header-item-active,
.card-dropdown-header-item:hover {
  background-color: #292929;
}
.card-dropdown-content {
  padding: 5px;
}
.card-dropdown-content-item {
  padding: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 5px;
  transition: background-color 0.2s ease-in-out;
}
.card-dropdown-content-item:hover {
  background-color: grey;
  cursor: pointer;
}
.card-dropdown-content-item-left {
  width: 50px;
  display: flex;
  justify-content: center;
}
.card-dropdown-content-item-right {
  width: 280px;
  margin-left: 10px;
}

.card-dropdown-transition-enter {
  opacity: 0;
  /* transform: translate(-100%, 100%) rotate(360deg); */
}
.card-dropdown-transition-leave-to {
  opacity: 0;
  /* transform: translate(100%, 100%) rotate(360deg); */
}
.card-dropdown-transition-enter-active, .card-dropdown-transition-leave-active{
  transition: all 0.2s ease-in-out;
}

</style>
